import { JSX } from "react";

import type { IgNetworkRequestEventDetails } from "./plugin/plugin/utils";
import type { ProductVariantModel } from "./plugin/plugin/classes";
import type { ShopifyCartItemModel, ShopifyCartModel } from "./shopify";

export const MessageTypeList = [
  "NEW_ORGANIZATION",
  "UPDATE_CONFIG",
  "LOGIN_AS_ORG",
  "LOGGED_IN",
  "LOG_OUT",
  "RELOAD",
  "PREVIEW_EXPERIMENT",
  "INITIALIZED",
  "UPDATE_FIND_REPLACES",
  "NOT_LOGGED_IN",
  "PERFORMANCE_UPDATE",
  "NO_LOCAL_STORAGE",
  "CHECK_LOCAL_STORAGE",
  "ERROR_MESSAGE",
  "CURRENT_ORGANIZATION",
  "CONFIG_UPDATE_SUCCESS",
  "CONFIG_UPDATE_FAILED",
  "READY",
  "CLOSED",
  "igRequest",
] as const;

export type MessageType = (typeof MessageTypeList)[number];

export type GeoLocationType =
  | { GEO_LOCATION: string }
  | {
      city: string;
      region: string;
      country: string;
    };

export type PageType = "Selectors" | "Advanced" | "Noop";

export type PageMap = Record<string, (props: any) => JSX.Element>;

export interface IgPerformanceEntry {
  timesRan: number;
  totalDuration: number;
}

export type IgPerformanceLog = Map<string, IgPerformanceEntry>;

export interface IgWidgetMetrics {
  functions: IgPerformanceLog;
  mutationEvents: [events: number, elements: number];
}

export interface DisplayPriceDebugContext {
  inferredProductVariant?: ProductVariantModel;
  selector?: string | null;
}

export type AddToCartResult = {
  details: IgNetworkRequestEventDetails<unknown, ShopifyCartItemModel>;
  cart: ShopifyCartModel;
  targetLineItems: ShopifyCartItemModel[];
};

export type AdvancedTabType = "Performance";

export type IgErrors =
  | "track"
  | "circuitBroke"
  | "invalidSelector"
  // Preview mode could not load the build's preview file, so the session fell
  // back to the live-only config and the drafts being previewed are absent.
  | "preview-config";
